import { BrowserRouter as Router, Routes, Route, Link, NavLink } from "react-router-dom";
import Home from "./pages/Home";
import Favorites from "./pages/Favorites";
import "./App.css";

const App = () => {
  return (
    <Router>
      
<nav className="navbar">
  <NavLink to="/" className={({ isActive }) => isActive ? "active" : ""}>Home</NavLink>
  <NavLink to="/favorites" className={({ isActive }) => isActive ? "active" : ""}>Favorites</NavLink>
</nav>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/favorites" element={<Favorites />} />
      </Routes>
    </Router>
  );
};

export default App;
